import { IdentificationIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { Link } from 'react-router-dom';

import classNames from '../../../utils/classNames';
import { ROUTES } from '../../../utils/routes';

interface RedirectionCoproButtonsProps {
  coproId: number | string;
  type?: 'circle' | 'standard';
}

const RedirectionCoproButtons: React.FC<RedirectionCoproButtonsProps> = ({ coproId, type = 'circle' }) => {
  const buttonClass = classNames(
    'mr-2 p-1 hover:bg-gray-100 focus:outline-none',
    type === 'circle' && 'rounded-full',
    type === 'standard' && 'rounded flex flex-col items-center justify-center',
  );

  return (
    <Link
      to={ROUTES.ANALYZING_COPRO_MANAGING_ID.replace(':coproId', coproId.toString())}
      className={buttonClass}
    >
      <IdentificationIcon className="h-5 w-5 text-gray-600" />
      {type !== 'circle' && (
        <span className="ml-2 text-gray-600">Détails</span>
      )}
    </Link>
  );
};

export default RedirectionCoproButtons;
